import React, { useState } from "react";
import AppSidebar from "./AppSidebar";
import AppHeader from "./AppHeader";
import Backdrop from "./Backdrop";
import { Outlet, useLocation } from "react-router-dom";
import { useSidebar } from "../../context/SidebarContext";
import WizardChat from "../../components/profile/onboarding/WizardChat";
import FloatingChat from "../../components/chat/FloatingChat";

const MainLayout: React.FC = () => {
  const { isExpanded, isHovered, isMobileOpen } = useSidebar();
  const location = useLocation();
  const isConversationsPage = location.pathname === "/conversations";

  const [isWizardOpen, setIsWizardOpen] = useState(false);

  const mainContentMargin = isMobileOpen
    ? "ml-0"
    : isExpanded || isHovered
      ? "lg:ml-[290px]"
      : "lg:ml-[90px]";

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300 font-sans text-gray-900 dark:text-gray-100">
      <AppSidebar />
      <Backdrop />
      <div
        className={`flex flex-1 flex-col transition-all duration-300 ${mainContentMargin}`}
      >
        <AppHeader />
        <main
          className={
            isConversationsPage
              ? "flex-1 overflow-hidden w-full"
              : "mx-auto w-full max-w-screen-2xl p-4 md:p-6 2xl:p-10 lg:pt-0"
          }
        >
          <Outlet />
        </main>
      </div>
      <WizardChat onOpenChange={setIsWizardOpen} />
      {!isWizardOpen && <FloatingChat />}
    </div>
  );
};

export default MainLayout;
